/* eslint-disable no-prototype-builtins */
import React from 'react'
import { Link } from 'react-router-dom'

import blackDottedSpinnerGIF from '../../assets/dotted-black-trans-spinner-200.gif'
import turquoiseDottedSpinnerGIF from '../../assets/dotted-turquoise-trans-spinner-200.gif'
import whiteDottedSpinnerGIF from '../../assets/dotted-white-trans-spinner-200.gif'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { navbarHeight, footerHeight } from '../../helpers/variableDefaults'

import { seoPageTags, customAnalyticsEvent } from '../../helpers/analytics'

// 404 Not Found Page
const NotFound = () => {
  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        '404'
      )}

      {/* Body */}
      <Box 
        sx={{ 
          height: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
          width: '100vw', 
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
        }}
      >
        {/* Circles Orbiting GIF */}
        <Box component='img' src={blackDottedSpinnerGIF} alt='simcap gif' sx={{ width: 300 }} />

        {/* 404 Not Found text */}
        <Typography variant='h4'>Page Not Found!</Typography>

        {/* Link back to home.js */}
        <Typography as={Link} to="/" sx={{ textDecoration: 'underline' }}>Back to Home</Typography>
      </Box>
    </>
  )
}

export default NotFound